import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-machine",
  "use": "icon-machine-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-machine\"><path d=\"M0 0v307.2h1024V0z m307.2 204.8H102.4V102.4h204.8zM0 665.6h1024V358.4H0z m102.4-204.8h204.8v102.4H102.4zM0 1024h1024v-307.2H0z m102.4-204.8h204.8v102.4H102.4z\" p-id=\"2575\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/machine.svg
// module id = ocTq
// module chunks = 77